import { memo, type FC } from 'react';

import { dataTableSection } from '../../constants.ts';
import { useTableContext } from '../../context.tsx';
import { StyledLabel, NoteWrapper } from './styled.ts';
import type { NoteProps } from './types.ts';

export const Note: FC<NoteProps> = memo(function Note({ label, value, dataTestId }) {
  const { compact } = useTableContext();

  return (
    <NoteWrapper $compact={compact} {...dataTableSection} data-testid={dataTestId}>
      <StyledLabel noMargin>{label}</StyledLabel>
      {value}
    </NoteWrapper>
  );
});
